import React from "react";
import { Card, Table, Typography } from "antd";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
} from "recharts";
import { FaMapMarkerAlt } from "react-icons/fa";

const { Title, Text } = Typography;

const LocationReport = ({ locationData }) => {
  // Format data for Recharts
  const pieData =
    locationData?.salesByLocation?.map((loc) => ({
      name: loc._id,
      value: loc.totalSales,
    })) || [];

  // Custom colors for the pie chart
  const COLORS = [
    "#0088FE",
    "#00C49F",
    "#FFBB28",
    "#FF8042",
    "#8884d8",
    "#83a6ed",
  ];

  const columns = [
    {
      title: "Location",
      dataIndex: "_id",
      key: "location",
      render: (text) => (
        <div className="flex items-center">
          <FaMapMarkerAlt className="mr-2" /> {text}
        </div>
      ),
    },
    {
      title: "Total Sales",
      dataIndex: "totalSales",
      key: "sales",
      render: (amount) => `$${amount.toFixed(2)}`,
      sorter: (a, b) => a.totalSales - b.totalSales,
    },
    {
      title: "Orders",
      dataIndex: "orderCount",
      key: "orders",
      sorter: (a, b) => a.orderCount - b.orderCount,
    },
  ];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-2 border border-gray-200 shadow-md">
          <p className="font-semibold">{payload[0].name}</p>
          <p>${payload[0].value.toFixed(2)}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="space-y-4">
      <Card title="Sales by Location">
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={pieData}
              cx="50%"
              cy="50%"
              labelLine={true}
              outerRadius={80}
              fill="#8884d8"
              dataKey="value"
              label={({ name, percent }) =>
                `${name} ${(percent * 100).toFixed(0)}%`
              }
            >
              {pieData.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </Card>

      <Card title="Location Performance">
        <Table
          columns={columns}
          dataSource={locationData?.salesByLocation || []}
          rowKey="_id"
          pagination={false}
        />
      </Card>
    </div>
  );
};

export default LocationReport;
